<script>
  import AppConfig from '../app.config'

  export default {
    name: 'LinkFooter',
    props: {
      asList: {
        type: Boolean,
        default: false
      },
      dense: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      // link to german page if language is "de", otherwise to english page
      lang() {
        return this.$vuetify.lang.current === 'de' ? 'de' : 'en'
      },
      // create links depending on current gui language
      imprint() {
        return AppConfig.links[this.lang].imprint
      },
      privacy() {
        return AppConfig.links[this.lang].privacy
      },
      agb() {
        return AppConfig.links[this.lang].agb
      },
      toc() {
        return AppConfig.links[this.lang].toc
      },
      disclaimer() {
        return AppConfig.links[this.lang].disclaimer
      }
    }
  }
</script>

<template>
  <!-- Default: Horizontal bottom footer with link buttons -->
  <VFooter v-if="!asList" absolute>
    <VBtn text x-small class="mx-xl-2">
      <a :href="imprint" target="_blank" rel="noopener noreferrer">{{ $vuetify.lang.t('$vuetify.app.imprint') }}</a>
    </VBtn>
    <VBtn text x-small class="mx-xl-2">
      <a :href="privacy" target="_blank" rel="noopener noreferrer">{{ $vuetify.lang.t('$vuetify.app.privacy') }}</a>
    </VBtn>
    <VBtn text x-small class="mx-xl-2">
      <a :href="toc" target="_blank" rel="noopener noreferrer">{{ $vuetify.lang.t('$vuetify.app.toc') }}</a>
    </VBtn>
    <VBtn text x-small class="mx-xl-2">
      <a :href="agb" target="_blank" rel="noopener noreferrer">{{ $vuetify.lang.t('$vuetify.app.agb') }}</a>
    </VBtn>
    <VBtn text x-small class="mx-xl-2">
      <a :href="disclaimer" target="_blank" rel="noopener noreferrer">{{ $vuetify.lang.t('$vuetify.app.disclaimer') }}</a>
    </VBtn>
  </VFooter>
  <!-- as-list: Vertical bottom footer as list with link items -->
  <VFooter v-else absolute class="pa-0">
    <VList :dense="dense" width="100%">
      <VListItem link :href="imprint" target="_blank" rel="noopener noreferrer">
        <VListItemIcon>
          <VIcon>mdi-open-in-new</VIcon>
        </VListItemIcon>
        <VListItemContent>
          <VListItemTitle>{{ $vuetify.lang.t('$vuetify.app.imprint') }}</VListItemTitle>
        </VListItemContent>
      </VListItem>
      <VListItem link :href="privacy" target="_blank" rel="noopener noreferrer">
        <VListItemIcon>
          <VIcon>mdi-open-in-new</VIcon>
        </VListItemIcon>
        <VListItemContent>
          <VListItemTitle>{{ $vuetify.lang.t('$vuetify.app.privacy') }}</VListItemTitle>
        </VListItemContent>
      </VListItem>
      <VListItem link :href="toc" target="_blank" rel="noopener noreferrer">
        <VListItemIcon>
          <VIcon>mdi-open-in-new</VIcon>
        </VListItemIcon>
        <VListItemContent>
          <VListItemTitle>{{ $vuetify.lang.t('$vuetify.app.toc') }}</VListItemTitle>
        </VListItemContent>
      </VListItem>
      <VListItem link :href="agb" target="_blank" rel="noopener noreferrer">
        <VListItemIcon>
          <VIcon>mdi-open-in-new</VIcon>
        </VListItemIcon>
        <VListItemContent>
          <VListItemTitle>{{ $vuetify.lang.t('$vuetify.app.agb') }}</VListItemTitle>
        </VListItemContent>
      </VListItem>
      <VListItem link :href="disclaimer" target="_blank" rel="noopener noreferrer">
        <VListItemIcon>
          <VIcon>mdi-open-in-new</VIcon>
        </VListItemIcon>
        <VListItemContent>
          <VListItemTitle>{{ $vuetify.lang.t('$vuetify.app.disclaimer') }}</VListItemTitle>
        </VListItemContent>
      </VListItem>
    </VList>
  </VFooter>
</template>
